import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Editorial from "./pages/Editorial";
import ArticleDetail from "./pages/ArticleDetail";
import MediaKit from "./pages/MediaKit";
import Listen from "./pages/Listen";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Episodes from "./pages/Episodes";
import EpisodeDetail from "./pages/EpisodeDetail";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/editorial" element={<Editorial />} />
            <Route path="/editorial/:slug" element={<ArticleDetail />} />
            <Route path="/episodes" element={<Episodes />} />
            <Route path="/episodes/:slug" element={<EpisodeDetail />} />
            <Route path="/media-kit" element={<MediaKit />} />
            <Route path="/listen" element={<Listen />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
